export function formatDateArray(incomingdate) {
    if (!incomingdate) {
        return ["", "", ""];
    }
    const dateTime = new Date(incomingdate)
    const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    const date = new Date(dateTime);
    const day = String(date.getDate()).padStart(2, '0');
    const month = months[date.getMonth()];
    const year = String(date.getFullYear());
    return [day, month, year];
}